module.exports = __webpack_public_path__ + "static/img/Illustration_1_OPS.6f3f0142.svg";